function caracteristicaModel(data) {
  this.caracteristica = data.attributes?.caracteristica;
}
export default caracteristicaModel;
